import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Dt_Cal from "../../lib/ui/dt_cal";
import Typ_Add from "./fkn/typ_add";
import Typ_Edit from "./fkn/typ_edit";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Typ extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.typ = "P";
    this.state.vpa = [];
    this.state.aa = [];
    this.state.wnds = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.reg_kt();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  reg_kt() {
    var self = this;
    var prm = {};
    prm.req = "vip.vip_reg.kt_list";
    prm.typ = "P";
    //prm.typ = this.state.typ;

    net.sio_req(prm)
    .then(function(ret){
        //alert( JSON.stringify(ret) );

        for(var o of ret.rca) {
            //alert( JSON.stringify(o) );
        }
        self.setState({vpa: ret.rca });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

    typ_add() {
        var self = this;
        var wnds = {};
        wnds.typadd = 1;
        self.setState({ wnds: wnds });
    }
    typ_edit(vpo) {
        var self = this;
        var wnds = {};
        wnds.typedit = 1;
        wnds.vpo = vpo;
        self.setState({ wnds: wnds });
    }

  render() {
    return (
    <div className="web-p00 flex flex-col">

    <div className="web-p01">
    <div className="flex-row">
        <div className="">
            KORT TYPER
        </div>
        <div className="flex"></div>

        <button className="btn btn-hw-orange w150" onClick={() => this.typ_add() } aria-label="System" >
            LÄGG TILL
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.reg_kt() } aria-label="System" >
            VISA
        </button>
    </div>
    <div className="divider"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
				<th>Typ</th>
				<th>Text</th>
				<th>Serie ID</th>
				<th>Status</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.vpa.map((vpo, key) =>
            <tr key={key} onDoubleClick={ () => this.typ_edit(vpo) }>
                <td>{ vpo.vip00.v0ktyp }</td>
                <td>{ vpo.vip00.v0company }</td>
                <td>{ vpo.vip00.v0namn }</td>
                <td>{ vpo.vip00.v0status }</td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

    </div>

        { this.state.wnds.typedit ?<Typ_Edit wnds={ this.state.wnds } ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.typadd ? <Typ_Add wnds={ this.state.wnds } ctx={this} store={this.props.store} backdrop={true}/> : null }

    </div>
  );
    }
}
export default Reg_Typ;
